import { Box, Skeleton, styled } from '@mui/material';
import React from 'react';

import Card from '../../base/card';
import Spacer, { spc } from '../../base/spacer';

interface Props {
  className?: string;
}

const DetailsSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <Card className={className}>
      <Box className="border-left">
        <Skeleton variant="text" width={60} height={32} />
        <Spacer pb={spc.xxxs} />
        <Skeleton variant="text" width={100} height={20} />
        <Spacer pb={spc.xs} />
        <Skeleton variant="text" width={80} height={16} />
      </Box>
    </Card>
  );
};

export default styled(DetailsSkeleton)`
  .border-left {
    border-left: 2px solid;
    padding-left: 10px;
  }
`;
